export var RoundingType;
(function (RoundingType) {
    RoundingType[RoundingType["NONE"] = 1] = "NONE";
    RoundingType[RoundingType["NORMAL"] = 2] = "NORMAL";
    RoundingType[RoundingType["UP"] = 3] = "UP";
    RoundingType[RoundingType["DOWN"] = 4] = "DOWN";
})(RoundingType || (RoundingType = {}));
//# sourceMappingURL=rounding-type.js.map